<template>
  <div>
    <label class="control-label"
      >{{ title }}
      <span v-show="tempUpload" @click="clear" class="bold">
        - Отмена</span
      ></label
    >
    <div class="draw-image">
      <img v-if="newData" :src="newData" alt="" />
      <img v-else :src="value ? value : noImage" alt="" />
      <input
        :name="name"
        ref="fileupload"
        accept="image/*"
        type="file"
        @change="handleFileUpload"
      />
    </div>
  </div>
</template>
<script>
import { mapState } from "vuex";

export default {
  data: () => ({
    tempUpload: false,
    newData: null,
    oldData: null,
    noImage: require("@/assets/img/no-photo-available.png"),
  }),
  watch: {
    lastUpdate(val) {
      if (val) {
        this.tempUpload = false;
        this.$refs.fileupload.value = null;
      }
    },
  },
  computed: {
    ...mapState(["lastUpdate"]),
  },
  props: {
    title: {
      default: "",
    },
    value: {
      default: null,
    },
    name: {
      default: null,
    },
    MAX_WIDTH: {
      default: 1920,
    },
  },
  created() {
    this.oldData = this.value;
  },
  methods: {
    clear() {
      this.tempUpload = false;
      this.$refs.fileupload.value = null;
      this.newData = null;
      this.$emit("input", this.oldData);
    },
    async handleFileUpload(event) {
      if (event.target.files && event.target.files.length > 0) {
        const file = event.target.files[0];

        if (!file.size || file.size > 3145728) {
          this.$notify({
            title: "Размер или формат документа",
            message: "Слишком большой размер. Не более 3 МБ",
            icon: "ti-save",
            horizontalAlign: "right",
            verticalAlign: "top",
            type: "success",
          });

          return false;
        }

        const reader = new FileReader();
        reader.readAsDataURL(file);
        await reader.addEventListener("load", () => {
          this.newData = reader.result;
        });
        this.$emit("input", event.target.files[0]);
      }
    },
  },
};
</script>
<style lang="scss">
.draw-image {
  cursor: pointer;
  position: relative;
  height: 0;
  padding-top: 50%;
  overflow: hidden;
  border: 1px solid #ebebeb;
  border-radius: 10px;
  margin-bottom: 30px;
  input {
    z-index: 9;
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    width: 100%;
    height: 100%;
    opacity: 0;
  }
  img {
    z-index: 0;
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    object-fit: contain;
    width: 100%;
    height: 100%;
  }
}
</style>